import textWrap from '@/_modules/common/textWrap';

class _topInview {
  //constructor() {}

  init() {
    // タイトルアニメーション
    this.titles = document.querySelectorAll('.is-text-wrap');
    this.titles.forEach((title, x) => {
      title.querySelectorAll('.is-transition').forEach((el, yi) => {
        el.innerHTML = textWrap.wraSpan(el.textContent);
      });
    });
  }

  show(id) {
    document.getElementById(id).classList.add('is-anim-start');
  }
}

const topInview = new _topInview();

export default topInview;